import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from '../../utils/customBaseQuery';

export const tgBotApi = createApi({
	reducerPath: "tgBotApi",
	baseQuery: customBaseQuery,
	refetchOnFocus: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({

		// POST /botMesg — создание подписок
		sendOrderMesg: builder.mutation({
			query: (data) => ({
				url: "/send-order-mes",
				method: "POST",
				body: data,
				prefix: "tgBot"
			}),
		}),

		sendMesg: builder.mutation({
			query: (data) => ({
				url: "/send-mes",
				method: "POST",
				body: data,
				prefix: "tgBot"
			}),
		}),

	}),
});

export const {
	useSendOrderMesgMutation,
	useSendMesgMutation
} = tgBotApi;
